/* eslint-disable max-len */
import { Component, DestroyRef, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LanguageKey, Translation } from '@s2a/core';
import moment_ from 'moment-timezone';
import { ExternalSystemStatusItem } from '../../models/external-system.status.model';
const moment = moment_;

@Component({
  selector: 's2a-external-system-status-dialogue-component',
  templateUrl: './external-system-status-dialogue-component.html',
  styleUrl: './external-system-status-dialogue-component.scss',
  standalone: false,
})
export class ExternalSystemStatusDialogueComponent {
  expanded = false;
  timestamp: string;
  locale: LanguageKey;
  currentTimeStamp = moment().valueOf();
  intervalId: any;
  private destroyRef = inject(DestroyRef);
  constructor(
    public matDialogRef: MatDialogRef<ExternalSystemStatusDialogueComponent>,
    public translationService: Translation,
    @Inject(MAT_DIALOG_DATA) public data: ExternalSystemStatusItem,
  ) {
    this.timestamp = moment(Number(this.data.currentState.timestamp)).format('L HH:mm:ss');
    this.intervalId = setInterval(() => {
      this.currentTimeStamp = moment().valueOf();
    }, 1);
    this.destroyRef.onDestroy(() => {
      clearInterval(this.intervalId);
    });
  }

  /**
   * Method is used to open the support UI when contact support is clicked
   */
  onContactSupport() {
    this.matDialogRef.close(true);
  }

  /**
   * Method is used to close this dialog when close is clicked
   */
  onClose() {
    this.matDialogRef.close(false);
  }
}
